import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import MediaModal from './MediaModal';

const MediaCapture = ({ onCapture, questionId, isViewOnly = false, hasMedia = false }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="media-capture">
      <Button 
        variant="outline-primary"
        onClick={() => setShowModal(true)}
        className="d-flex align-items-center"
        disabled={isViewOnly}
        style={{
          opacity: isViewOnly ? 0.6 : 1,
          cursor: isViewOnly ? 'not-allowed' : 'pointer',
          pointerEvents: isViewOnly ? 'none' : 'auto'
        }}
      >
        <i className="fas fa-paperclip me-2" />
        {hasMedia ? 'Replace Media' : 'Attach Media'}
      </Button>

      <MediaModal
        show={showModal && !isViewOnly}
        onHide={() => setShowModal(false)}
        onCapture={onCapture}
        questionId={questionId}
      />
    </div>
  );
};

export default MediaCapture;